import { getCountryCallingCode } from "../../../libphonenumber-js/es6/metadata.js";
function getPrefixForFormattingValueAsPhoneNumber(_ref) {
  var inputFormat = _ref.inputFormat, country = _ref.country, metadata = _ref.metadata;
  return inputFormat === "NATIONAL_PART_OF_INTERNATIONAL" ? "+".concat(getCountryCallingCode(country, metadata)) : "";
}
function removePrefixFromFormattedPhoneNumber(value, prefix) {
  return prefix && (value = value.slice(prefix.length), value[0] === " " && (value = value.slice(1))), value;
}
export {
  getPrefixForFormattingValueAsPhoneNumber,
  removePrefixFromFormattedPhoneNumber
};
//# sourceMappingURL=inputValuePrefix.js.map
